// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_fx","advertDetailContacts__header":"c-m_fy"};